<template>
    <MicroAppPortfolioListPage>
        <template #description>
            <p class="mt-7 text-16/148 font-medium">
                Работаем с&nbsp;2010 года&nbsp;&mdash; производим и&nbsp;продаём
                оборудование для экскурсий, конференций и&nbsp;доступной среды.
                <br /><br />
                Вы&nbsp;можете познакомиться с&nbsp;некоторыми нашими проектами,
                которые реализованы за&nbsp;15&nbsp;лет успешной работы.*
            </p>
            <p class="mt-3 text-12/140 font-medium">
                * &mdash; большую часть мы&nbsp;не&nbsp;можем показать
                по&nbsp;NDA
            </p>
        </template>
    </MicroAppPortfolioListPage>
</template>
<script setup lang="ts">
import MicroAppPortfolioListPage from '~/components/micro-app/MicroAppPortfolioListPage.vue'
</script>
